module.exports = __webpack_public_path__ + "img/image 35.f0c3e84e.svg";